import {validarCampo} from "../Funciones/validarCampo";

export const adap_bodega_guia = ({bodega, pedido}) => {

    let obj = {

        "token_quote": pedido.tokenEnvio,
        "content": bodega.contenido,
        "origin_first_name": validarCampo({texto: bodega.nombres}),
        "origin_last_name": validarCampo({texto: bodega.apellidos}),
        "origin_email": validarCampo({texto: bodega.correo, max: 35}),
        "origin_street": validarCampo({texto: bodega.calle, max: 35}),
        "origin_number": validarCampo({texto: bodega.numero, max: 15}),
        "origin_neighborhood": validarCampo({texto: bodega.barrio, max: 35}),
        "origin_phone": validarCampo({texto: bodega.celular, max: 10, min: 8}),
        "origin_state": validarCampo({texto: bodega.estado, max: 35}),
        "origin_municipality": validarCampo({texto: bodega.municipio, max: 35}),
        "origin_references": validarCampo({texto: bodega.referencia, max: 35}),
        "destination_first_name": validarCampo({texto: pedido.nombres, max: 25}),
        "destination_last_name": validarCampo({texto: pedido.apellidos, max: 25}),
        "destination_email": validarCampo({texto: pedido.correo, max: 35}),
        "destination_street": validarCampo({texto: pedido.calle, max: 35}),
        "destination_number": validarCampo({texto: pedido.numero, max: 15, min: 1}),
        "destination_neighborhood": validarCampo({texto: pedido.barrio, max: 35}),
        "destination_phone": validarCampo({texto: pedido.celular, min: 8, max: 10}),
        "destination_state": validarCampo({texto: pedido.estadoMexico, max: 35}),
        "destination_municipality": validarCampo({texto: pedido.municipio, max: 35}),
        "destination_references": validarCampo({texto: pedido.referencia, max: 35}),
        "packages": 1,
        "generate_pickup": false,
        "has_notification": true,
        "guide_origin": "t1envios"

    }

    return obj

}

